export const isWeightBold = (value: string | undefined): boolean => {
	if (value === undefined) {
		return false
	}

	if (value === 'bold') {
		return true
	}

	const weightAsNumber = parseInt(value, 10)
	return weightAsNumber >= 700
}
